{
 "generic": [
  {
   "id": "g01",
   "text": "That's the name you picked? Bold. Wrong, but bold.",
   "file": "assets/vo/roast-g01.mp3",
   "dur": 4.6
  },
  {
   "id": "g02",
   "text": "I've seen better names on a cereal box. A store brand one.",
   "file": "assets/vo/roast-g02.mp3",
   "dur": 5.48
  },
  {
   "id": "g03",
   "text": "Congratulations. You typed a name. Your mother must be so proud.",
   "file": "assets/vo/roast-g03.mp3",
   "dur": 8.03
  },
  {
   "id": "g04",
   "text": "Oh no. Oh no no no. Well, it's too late now. It's on the server.",
   "file": "assets/vo/roast-g04.mp3",
   "dur": 8.87
  },
  {
   "id": "g05",
   "text": "That name has the energy of a wet sock in a hurricane.",
   "file": "assets/vo/roast-g05.mp3",
   "dur": 6.08
  },
  {
   "id": "g06",
   "text": "Every champion needs a name. Unfortunately, so do you.",
   "file": "assets/vo/roast-g06.mp3",
   "dur": 7.15
  },
  {
   "id": "g07",
   "text": "I'll remember that name. Mostly so I can laugh at it later.",
   "file": "assets/vo/roast-g07.mp3",
   "dur": 5.02
  },
  {
   "id": "g08",
   "text": "Wow. Even the keyboard sounded embarrassed.",
   "file": "assets/vo/roast-g08.mp3",
   "dur": 4.04
  },
  {
   "id": "g09",
   "text": "That's not a warrior's name. That's a sneeze with confidence.",
   "file": "assets/vo/roast-g09.mp3",
   "dur": 7.29
  },
  {
   "id": "g10",
   "text": "Welcome, legend. And by legend, I mean nobody. Yet.",
   "file": "assets/vo/roast-g10.mp3",
   "dur": 6.41
  },
  {
   "id": "g11",
   "text": "The arena has seen many names. This one made it flinch.",
   "file": "assets/vo/roast-g11.mp3",
   "dur": 5.94
  },
  {
   "id": "g12",
   "text": "Typed with such passion. Spelled with such regret.",
   "file": "assets/vo/roast-g12.mp3",
   "dur": 5.2
  }
 ],
 "offensive": [
  {
   "id": "o01",
   "text": "Nice try. That name goes straight in the bin, right next to your dignity. Pick another.",
   "file": "assets/vo/roast-o01.mp3",
   "dur": 7.43
  },
  {
   "id": "o02",
   "text": "Wow. Edgy. The comedy stylings of a thirteen year old. Try a real name.",
   "file": "assets/vo/roast-o02.mp3",
   "dur": 9.1
  },
  {
   "id": "o03",
   "text": "No. Absolutely not. I have standards, and you just tripped over every one of them.",
   "file": "assets/vo/roast-o03.mp3",
   "dur": 9.01
  },
  {
   "id": "o04",
   "text": "That name got rejected faster than your last text. Try again.",
   "file": "assets/vo/roast-o04.mp3",
   "dur": 6.41
  }
 ],
 "takes": {
  "g01": {
   "voice": "s",
   "line": "That's the name you picked? Bold. Wrong, but bold.",
   "hash": "dfe05a237cfb963c",
   "dur": 4.6,
   "stt": 1,
   "pass": true,
   "takes": 1,
   "heard": "That's the name you picked? Bold. Wrong, but bold"
  },
  "g02": {
   "voice": "s",
   "line": "I've seen better names on a cereal box. A store brand one.",
   "hash": "ffcb2dac07113e07",
   "dur": 5.48,
   "stt": 1,
   "pass": true,
   "takes": 1,
   "heard": "I've seen better names on a cereal box, a store brand one"
  },
  "g03": {
   "voice": "s",
   "line": "Congratulations. You typed a name. Your mother must be so proud.",
   "hash": "62b043740e2e6f28",
   "dur": 8.03,
   "stt": 1,
   "pass": false,
   "takes": 1,
   "heard": "Congratulations. You typed a name. Your mother must be so proud"
  },
  "g04": {
   "voice": "s",
   "line": "Oh no. Oh no no no. Well, it's too late now. It's on the server.",
   "hash": "a91383715e8d1acd",
   "dur": 8.87,
   "stt": 1,
   "pass": false,
   "takes": 1,
   "heard": "Oh no. Oh no, no, no. Well, it's too late now. It's on the server"
  },
  "g05": {
   "voice": "s",
   "line": "That name has the energy of a wet sock in a hurricane.",
   "hash": "26ccf6aa4a4317d9",
   "dur": 6.08,
   "stt": 1,
   "pass": true,
   "takes": 1,
   "heard": "That name has the energy of a wet sock in a hurricane"
  },
  "g06": {
   "voice": "s",
   "line": "Every champion needs a name. Unfortunately, so do you.",
   "hash": "e7d743b3d6d5a5d2",
   "dur": 7.15,
   "stt": 1,
   "pass": true,
   "takes": 1,
   "heard": "Every champion needs a name. Unfortunately, so do you"
  },
  "g07": {
   "voice": "s",
   "line": "I'll remember that name. Mostly so I can laugh at it later.",
   "hash": "70181075f6c7e26f",
   "dur": 5.02,
   "stt": 1,
   "pass": true,
   "takes": 1,
   "heard": "I'll remember that name, mostly so I can laugh at it later"
  },
  "g08": {
   "voice": "s",
   "line": "Wow. Even the keyboard sounded embarrassed.",
   "hash": "07ab0fd1d04fded8",
   "dur": 4.04,
   "stt": 1,
   "pass": true,
   "takes": 1,
   "heard": "Wow, even the keyboard sounded embarrassed"
  },
  "g09": {
   "voice": "s",
   "line": "That's not a warrior's name. That's a sneeze with confidence.",
   "hash": "22061e109223fb0e",
   "dur": 7.29,
   "stt": 1,
   "pass": true,
   "takes": 1,
   "heard": "That's not a warrior's name. That's a sneeze with confidence"
  },
  "g10": {
   "voice": "s",
   "line": "Welcome, legend. And by legend, I mean nobody. Yet.",
   "hash": "722377d845e869bb",
   "dur": 6.41,
   "stt": 1,
   "pass": true,
   "takes": 1,
   "heard": "Welcome, legend. And by legend, I mean nobody yet"
  },
  "g11": {
   "voice": "s",
   "line": "The arena has seen many names. This one made it flinch.",
   "hash": "c7e24053c2259ef3",
   "dur": 5.94,
   "stt": 1,
   "pass": true,
   "takes": 1,
   "heard": "The arena has seen many names. This one made it flinch"
  },
  "g12": {
   "voice": "s",
   "line": "Typed with such passion. Spelled with such regret.",
   "hash": "b913b2bad1513bfc",
   "dur": 5.2,
   "stt": 1,
   "pass": true,
   "takes": 1,
   "heard": "Typed with such passion, spelled with such regret"
  },
  "o01": {
   "voice": "s",
   "line": "Nice try. That name goes straight in the bin, right next to your dignity. Pick another.",
   "hash": "be3d0196ace1dc98",
   "dur": 7.43,
   "stt": 1,
   "pass": true,
   "takes": 1,
   "heard": "Nice try. That name goes straight in the bin, right next to your dignity. Pick another"
  },
  "o02": {
   "voice": "s",
   "line": "Wow. Edgy. The comedy stylings of a thirteen year old. Try a real name.",
   "hash": "64bd5738e6f9554a",
   "dur": 9.1,
   "stt": 0.929,
   "pass": false,
   "takes": 1,
   "heard": "Wow, edgy. The comedy stylings of a 13-year-old. Try a real name"
  },
  "o03": {
   "voice": "s",
   "line": "No. Absolutely not. I have standards, and you just tripped over every one of them.",
   "hash": "7c47da6833633f30",
   "dur": 9.01,
   "stt": 1,
   "pass": false,
   "takes": 1,
   "heard": "No, absolutely not. I have standards, and you just tripped over every one of them"
  },
  "o04": {
   "voice": "s",
   "line": "That name got rejected faster than your last text. Try again.",
   "hash": "477f8cfac66b20a5",
   "dur": 6.41,
   "stt": 1,
   "pass": true,
   "takes": 1,
   "heard": "That name got rejected faster than your last text. Try again"
  }
 }
}
